import destroy from './destroy';
import store from './store';
import show from './show';
import update from './update';
import all from './all';
import items from './items';
import warehouseProduct from './warehouseProduct';
import warehouseProducts from './warehouseProducts';
import downloadProduct from './downloadProduct';
import updateDraft from './updateDraft';
import saveDraft from './saveDraft';

export default {
  destroy,
  store,
  show,
  update,
  all,
  items,
  warehouseProduct,
  warehouseProducts,
  downloadProduct,
  updateDraft,
  saveDraft,
};



// WEBPACK FOOTER //
// ./src/app/services/stock/index.js